import { Context } from '@front10/helpers/dist/Context';
import useStyles from '@front10/helpers/dist/UseStyles';
import React, { useContext } from 'react';
import Box from './../../../elements/Box';

export default function Alert(props) {
  const { direction, theme, translate } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  const getLabelKey = () => {
    if (props.activeTab) {
      return props.activeTab === 'start'
        ? 'cmp-low-fare-calendar-oi-alert-info-departure'
        : 'cmp-low-fare-calendar-oi-alert-info-return';
    } else {
      return 'cmp-low-fare-calendar-oi-alert-info-one-way';
    }
  };

  const getDefaultValue = () => {
    if (props.activeTab) {
      return `Please select a your <b>${
        props.activeTab === 'start' ? 'departure' : 'return'
      }</b> date in the calendar below.`;
    } else {
      return 'Below the first lowest fare has been selected for you. Interact with with the calendar below to find your desired date.';
    }
  };
  return (
    <>
      <Box tabIndex={props.tabIndex ?? '-1'} {...props}>
        <span
          className={`fr-alert ${className}`}
          style={style}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: translate(getLabelKey(), getDefaultValue())
          }}
        />
      </Box>
    </>
  );
}
